import React from 'react';
import { Redirect } from 'react-router-dom';
import OtpRegistration from '../otp_registration';
import OtpEntry from '../otp_entry';
import OtpRecovery from '../otp_recovery';
import OtpRecoveryCodes from '../otp_recovery_codes';

const TwoFactorRenderer = ({
  mode,
  routeProps,
  recoveryCodes,
  completedUser,
  onRegistrationComplete,
  onUpdateAuthState,
  onClearRecoveryData,
}) => {
  const navigateToLogin = () => {
    window.location.href = '/member/login';
  };

  const navigateToVerify = () => {
    onUpdateAuthState({ required_action: 'verify' });
  };

  const navigateToRecovery = () => {
    onUpdateAuthState({ required_action: 'recovery' });
  };

  const handleRecoveryCodesComplete = () => {
    onClearRecoveryData();
    // Let the component handle the redirect with the user data
  };

  switch (mode) {
    case 'register':
      return <OtpRegistration {...routeProps} onComplete={onRegistrationComplete} />;

    case 'verify':
      return (
        <OtpEntry {...routeProps} standalone={true} onCancel={navigateToLogin} onRecoveryClick={navigateToRecovery} />
      );

    case 'recovery':
      return <OtpRecovery {...routeProps} onBackClick={navigateToVerify} onCancel={navigateToLogin} />;

    case 'show_recovery_codes':
      return (
        <OtpRecoveryCodes recoveryCodes={recoveryCodes} user={completedUser} onContinue={handleRecoveryCodesComplete} />
      );

    default:
      return <Redirect to='/member/login' />;
  }
};

export default TwoFactorRenderer;
